import { React } from "react";
import { Button, Table } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

const EquipmentTable = ({ content, setSelectedItem }) => {
  const columns = [
    {
      title: "Brand",
      dataIndex: ["equipment", "brand"],
      width: 150,
      sorter: (a, b) => a.equipment.brand.localeCompare(b.equipment.brand),
    },
    {
      title: "Model",
      dataIndex: ["equipment", "model"],
      width: 150,
      sorter: (a, b) => a.equipment.model.localeCompare(b.equipment.model),
    },
    {
      title: "Category",
      dataIndex: ["equipment", "category"],
      width: 150,
      sorter: (a, b) =>
        a.equipment.category.localeCompare(b.equipment.category),
    },
    {
      title: "Clinic",
      dataIndex: "clinicNo",
      width: 100,
      sorter: (a, b) => a.clinicNo.localeCompare(b.clinicNo),
    },
    {
      title: "Modified By",
      dataIndex: "modified",
      width: 200,
      sorter: (a, b) => a.modified.lastName.localeCompare(b.modified.lastName),
      render: (modified) =>
        `${modified.firstName} ${modified.lastName} (${modified.initials})`,
    },

    {
      title: "In Use",
      dataIndex: "status",
      align: "center",
      width: 100,
      render: (status) =>
        status === "In Use" ? <CheckOutlined /> : <CloseOutlined />,
    },
    {
      title: "Working",
      dataIndex: "condition",
      align: "center",
      width: 100,
      render: (condition) =>
        condition === "Working" ? <CheckOutlined /> : <CloseOutlined />,
    },
    {
      title: "Detail",
      dataIndex: "",
      width: 100,
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          onClick={() => {
            setSelectedItem(record.id);
          }}
        >
          Detail
        </Button>
      ),
    },
  ];

  return (
    <>
      <Table
        bordered
        columns={columns}
        size="middle"
        dataSource={content}
        rowKey="id"
      />
    </>
  );
};

export default EquipmentTable;
